(function() {
	'use strict';
    // Directives related to the profile page

    angular.module('GorillaBoy.directives')
    .directive('storageUsed', ['SourceConstant', '$rootScope', '$filter', function (SourceConstant, $rootScope, $filter) {
        return {
            restrict: 'E',
            scope: {
                value: '=', // Storage usage
                total: '=', // Total storage. If this is set to 0, assume unlimited.
                width: '=', // Total width of the box
                type: '=', // UNLIMITED or QUOTA
                tabindex: '=' // Tab index to be set
            },
            link: function (scope, element, attr) {
                // If percentage > 90, show danger.
                var PERCENTAGE_LIMIT = 0.9,
                	PERCENTAGE_WARNING = 0.5;
                scope.UNLIMITED_TYPE = 'UNLIMITED';

                scope.percent = function() { return (scope.type === scope.UNLIMITED_TYPE) ? 0 : (Number(scope.value) / Number(scope.total)); };
                scope.formatBytes = $filter('getHumanReadableSize');
                var scopePercent = scope.percent();
                if (scopePercent < PERCENTAGE_WARNING){
                    scope.storageClass = 'storage-used-free';
                } else if (scopePercent >= PERCENTAGE_WARNING && scopePercent < PERCENTAGE_LIMIT){
                    scope.storageClass = 'storage-used-warning';
                } else {
                    scope.storageClass = 'storage-used-limit';
                }
            },
            templateUrl: function(element, attr) {
            	if (attr.id === 'profile-storage') {
            		return './profile/storage_used_profile.html';
            	} else {
            		return './admin/storage_used.html';
            	}
            }
        };
    }]);
}());